import { render, staticRenderFns } from "./finance.vue?vue&type=template&id=a25fd4fc&scoped=true"
import script from "./finance.vue?vue&type=script&lang=js"
export * from "./finance.vue?vue&type=script&lang=js"
import style0 from "./finance.vue?vue&type=style&index=0&id=a25fd4fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a25fd4fc",
  null
  
)

export default component.exports